'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useLocalStorage } from '@uidotdev/usehooks';
import { useGetFeatureFlag } from '@/lib/feature-flags/hooks/use-get-feature-flag';
import type { FeatureFlagVariant } from '@/lib/feature-flags/types';
const PASSWORDLESS_SIGN_UP_VARIANT_STORAGE_KEY = '__ab_test_passwordless_sign_up_2026_q3_variant';
interface UsePasswordlessSignUpVariantReturn {
  isPasswordless: boolean;
  variant: FeatureFlagVariant | undefined;
}

// Same read-and-cache shape as `useSignUpQ1Variant`: PostHog wins when it has answered, and the cached
// value covers the gap before it does, so a returning visitor does not watch the password field appear
// and then vanish. Fails closed: only an explicit `experiment` is passwordless.
export function usePasswordlessSignUpVariant() {
  const $ = _c(8);
  const [storedVariant, setStoredVariant] = useLocalStorage(PASSWORDLESS_SIGN_UP_VARIANT_STORAGE_KEY, null);
  const posthogVariant = useGetFeatureFlag("ab_test_passwordless_sign_up_2026_q3");
  const resolvedVariant = posthogVariant ?? storedVariant ?? undefined;
  const variant = resolvedVariant === "control" || resolvedVariant === "experiment" ? resolvedVariant : undefined;
  let t0;
  let t1;
  if ($[0] !== posthogVariant || $[1] !== setStoredVariant || $[2] !== storedVariant) {
    t0 = () => {
      if (posthogVariant === undefined || storedVariant === posthogVariant) {
        return;
      }
      setStoredVariant(posthogVariant);
    };
    t1 = [storedVariant, posthogVariant, setStoredVariant];
    $[0] = posthogVariant;
    $[1] = setStoredVariant;
    $[2] = storedVariant;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  const t2 = variant === "experiment";
  let t3;
  if ($[5] !== t2 || $[6] !== variant) {
    t3 = {
      isPasswordless: t2,
      variant
    };
    $[5] = t2;
    $[6] = variant;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}